import { Component } from '@angular/core';
import { Select, Store } from '@ngxs/store';
import { ProductState } from '@platform-frontend/checkout';
import { Product } from '@platform-frontend/marketplace';
import { CloseWindow } from '@platform-frontend/util';
import { Observable } from 'rxjs';

@Component({
  selector: 'yat-overview',
  templateUrl: './overview.component.html',
  styleUrls: ['./overview.component.scss']
})
export class OverviewComponent {
  constructor(private store: Store) {}

  @Select(ProductState.product)
  product$: Observable<Product | null>;

  close(): void {
    this.store.dispatch(new CloseWindow());
  }
}
